module.exports = __webpack_public_path__ + "static/media/gmail_icon.9dbc79da.svg";